import { CreatePopUpForm } from '../types/popupForm';
import base from './base';

const popUpForms = {
  postPopUpForm(body: CreatePopUpForm) {
    return base.post(`/pop-up-forms`, body);
  },
};

export default popUpForms;
